import { useState } from 'react';
import { Info } from './Info';
import { PhotoEdit } from './PhotoEdit';
import cls from './UserInfo.module.scss';

export const UserInfo = () => {
    const [isEditingPhoto, setIsEditingPhoto] = useState(false);

    const Component = isEditingPhoto ? PhotoEdit : Info;

    return (
        <div className={cls.container}>
            <Component setIsEditingPhoto={setIsEditingPhoto} />
        </div>
    );
};
